import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaFireExtinguisher, FaGraduationCap, FaTools, FaSearch, FaShieldAlt, FaWrench, FaMap, FaBolt, FaDoorClosed } from 'react-icons/fa';


// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'emergency response':
      return <FaFireExtinguisher />; // Fire extinguisher icon

    case 'safety training':
      return <FaGraduationCap />; // Graduation cap icon

    case 'equipment maintenance':
      return <FaTools />; // Tools icon

    case 'fire drills':
      return <FaUsers />; // Users/people icon

    case 'incident investigations':
      return <FaSearch />; // Search icon

    case 'mitigation consultation':
      return <FaShieldAlt />; // Shield icon

    /*----- Preventions Icons -----*/
    case 'install fire alarms':
      return <FaWrench />; // Wrench icon

    case 'create escape plan':
      return <FaMap />; // Map icon

    case 'fire extinguisher training':
      return <FaFireExtinguisher />; // Fire extinguisher icon

    case 'check electrical wiring':
      return <FaBolt />; // Bolt/lightning icon

    case 'maintain fire exits':
      return <FaDoorClosed />; // Door closed icon

    case 'educate residents':
      return <FaGraduationCap />; // Graduation cap icon

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
    case 'time':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
    case 'venue':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
    case 'entryfee':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'firechief':
    case 'organizer':
      return <FaUserTie />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    default:
      return null; // Return null if no matching icon is found
  }

};